<template>
  <div class="gmf-comment-voting" v-if="selectedVoteMode === 'up_down'">
    <button class="gmf-comment-footer-btn" @click.stop="vote($event, 1)">
      <LikeAnimation ref="upvoteAnimation" icon="upvote" color="var(--gmf-col-upvote)">
        <Icon
          class="gmf-comment-upvote"
          :class="{'gmf-selected': votes.observerVote > 0}"
          :icon="votes.observerVote > 0 ? 'upvote' : 'upvote-gray'"
        />
      </LikeAnimation>
    </button>
    <span class="gmf-comment-vote-score">{{ votes.score }}</span>
    <button class="gmf-comment-footer-btn" @click.stop="vote($event, -1)">
      <LikeAnimation ref="downvoteAnimation" icon="downvote" color="var(--gmf-col-downvote)">
        <Icon
          class="gmf-comment-downvote"
          :class="{'gmf-selected': votes.observerVote < 0}"
          :icon="votes.observerVote < 0 ? 'downvote' : 'downvote-gray'"
        />
      </LikeAnimation>
    </button>
  </div>
  <button class="gmf-comment-footer-btn" v-else-if="selectedVoteMode === 'like'" @click.stop="vote($event, 1)">
    <LikeAnimation ref="likeAnimation" icon="like" color="var(--gmf-col-like)">
      <Icon
        class="gmf-comment-like-icon"
        :class="{'gmf-selected': votes.observerVote > 0}"
        :icon="votes.observerVote > 0 ? 'like' : 'like-gray'"
      />
    </LikeAnimation>
    <slot name="like-text">
      <span v-if="! hideText">{{ votes.score }} {{ pluralizedLikes }}</span>
      <span v-else>{{ votes.score }}</span>
    </slot>
  </button>
</template>

<style>
.gmf-context .gmf-comment-voting {
  font-size: var(--gmf-default-font-size);
  color: var(--gmf-col-darkgray);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.gmf-comment-voting .gmf-comment-footer-btn {
  padding: 0 !important;
}
.gmf-sp .gmf-comment-voting, .gmf-comment .gmf-comment-voting {
  padding: 4px 8px;
}

.gmf-comment-upvote.gmf-selected {
  --gmf-icon-color: var(--gmf-col-upvote);
}
.gmf-comment-downvote.gmf-selected {
  --gmf-icon-color: var(--gmf-col-downvote);
}
.gmf-comment-like-icon.gmf-selected {
  --gmf-icon-color: var(--gmf-col-like);
}
</style>

<script>
/*

@TODO
lets stop calling these buttons comment-footer-btn since we can now use them in mutliple locations

*/
import state from '@/state';
import callApi from '@/utils/callApi';
import tooltip from '@/utils/tooltip';
import Icon from '@/components/Icon';
import LikeAnimation from '@/components/LikeAnimation';

const t = state.t.prefix('comments');

export default {
  props: ['comment', 'voteMode', 'hideText'],
  components: { Icon, LikeAnimation },
  emits: ['update:votes'],
  data () {
    const votes = {
      downvotes: 0,
      score: 0,
      upvotes: 0,
      observerVote: 0,
    };

    if (this.comment) {
      Object.assign(votes, this.comment.votes);
    }

    // @TODO watch comment and update votes if it is changed externally

    return {
      votes,
      state,
    };
  },
  computed: {
    pluralizedLikes () {
      if (Math.abs(this.votes.score) === 1) {
        return t('like');
      }
      return t('likes');
    },
    selectedVoteMode () {
      return this.voteMode || state.merchantConfig.voteMode;
    },
    profile() {
      return this.state.profile;
    }
  },
  methods: {
    vote (ev, vote) {
      if (!this.profile) {
        tooltip.create({x: ev.pageX, y: ev.pageY}, t('error_text.log_in_to_to_vote'));
        return false;
      }

      if (this.profile && this.profile.id === this.comment.author.id) {
        tooltip.create({x: ev.pageX, y: ev.pageY}, t('error_text.dont_vote_own_comment'));
        return false;
      }

      if (vote === this.votes.observerVote) {
        vote = 0;
      }

      const prevCustomerVote = this.votes.observerVote || 0;
      const prevVoteScore = this.votes.score;

      this.votes.score += vote - prevCustomerVote;

      // @TODO downvote count / upvote count

      this.votes.observerVote = vote;

      callApi('POST', '/v1/comment-votes/' + this.comment.id, { vote })
        .then(async res => {

          if (res.status === 200) {
            this.$emit('update:votes', this.votes);
            
            // Trigger animation based on vote type
            if (vote > 0) {
              if (this.selectedVoteMode === 'like' && this.$refs.likeAnimation) {
                this.$refs.likeAnimation.trigger();
              } else if (this.selectedVoteMode === 'up_down' && this.$refs.upvoteAnimation) {
                this.$refs.upvoteAnimation.trigger();
              }
            } else if (vote < 0) {
              if (this.selectedVoteMode === 'up_down' && this.$refs.downvoteAnimation) {
                this.$refs.downvoteAnimation.trigger();
              }
            }
          } else {
            // Something went wrong, undo vote
            this.votes.score = prevVoteScore;
            this.votes.observerVote = prevCustomerVote;

            let errorPhrase = 'error_text.could_not_vote_try_again';
            if (res.status === 400) {
              const body = await res.json();
              if (body.error && body.error.code === 104101) {
                errorPhrase = 'error_text.dont_vote_own_comment';
              }
            } else if (res.status === 401) {
              errorPhrase = 'error_text.log_in_to_to_vote';
            }

            tooltip.create({
              x: ev.pageX,
              y: ev.pageY,
            }, t(errorPhrase));
          }
        });

      return true;
    },
  },


};
</script>
